{
  "version": 1,
  "asset_id": "aeaf9998-72b8-4910-8e26-0ddc407ffa29",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/aeaf9998-72b8-4910-8e26-0ddc407ffa29/bypass-revision-resection-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/aeaf9998-72b8-4910-8e26-0ddc407ffa29/bypass-revision-resection-es-1200.webp",
  "original_filename": "bypass-revision-resection-es-1200.webp",
  "size": 141570,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:41:43Z"
}
